<div class="tile-group-field">
  <label class="tile-group-label" [id]="id + '-label'">
    {{ label }}
    <span *ngIf="required"> *</span>
  </label>
  <div
    class="tile-group"
    [class.tile-group-invalid]="isInvalid"
    role="radiogroup"
    [id]="id"
    tabindex="-1"
    [attr.aria-labelledby]="id + '-label'"
    [attr.aria-required]="required ? 'true' : null"
    [attr.aria-invalid]="isInvalid"
    [attr.aria-describedby]="isInvalid ? errorId : null"
  >
    <button
      #tileButton
      type="button"
      class="tile"
      *ngFor="let option of options; let i = index"
      role="radio"
      [attr.aria-checked]="isSelected(option.value)"
      [attr.tabindex]="tabIndexFor(option.value, i)"
      [class.tile-selected]="isSelected(option.value)"
      [class.tile-unselected]="!isSelected(option.value)"
      (click)="selectOption(option.value)"
      (keydown)="onKeydown($event, i)"
    >
      <span class="tile-label">{{ option.label }}</span>
      <span class="tile-description" *ngIf="option.description">{{
        option.description
      }}</span>
    </button>
  </div>
  <p [id]="errorId" class="tile-group-error" *ngIf="isInvalid">
    {{ errorText }}
  </p>
</div>
